module.exports = __webpack_public_path__ + "static/media/cookies.f6ab0c07.png";